var mapShortToLong = {
    'key': 'key',
    'parentKey': 'parentKey',
    'label': 'label',
    'value': 'value',
    'showCheckbox': 'showCheckbox',
    'icon': 'icon',
    'child': 'children'
  };
  

const ListToTree = {

    listToTree : function(data, options){
        options = options || {};
        var KEY_ID = options.key_id || 'id';
        var KEY_PARENT = options.key_parent || 'parent';
        var KEY_CHILD = options.key_child || 'children';
      
        var tree = [],
          childrenOf = {};
        var item, id, parentId;
      
        for (var i = 0, length = data.length; i < length; i++) {
          item = data[i];
          id = item[KEY_ID];
          parentId = item[KEY_PARENT] || 0;
          // every item may have children
          childrenOf[id] = childrenOf[id] || [];
          // init its children
          item[KEY_CHILD] = childrenOf[id];
          if (parentId != 0) {
            // init its parent's children object
            childrenOf[parentId] = childrenOf[parentId] || [];
            // push it into its parent's children object
            childrenOf[parentId].push(item);
          } else {
            tree.push(item);
          }
        };
      
        return tree;
    },

    refit_keys:function(o){
        var build, key, destKey, ix, value = [];

        build = [];
        for (key in o) {
          // Get the destination key
          destKey = mapShortToLong[key] || key;
      
          // Get the value
          value = o[key];
      
          //If this is an object, recurse
          if (typeof value === "object") {
            value = ListToTree.refit_keys(value);
          }
      
          // Set it on the result using the destination key
          build[destKey] = value;
          //build.push(value)
        }
        return build;
    }
}

export default ListToTree;